import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";

import Button from "react-bootstrap/Button";


import FldCloseIcon from "../images/round-close-icon.svg";

import ValidationAlertIcon from "../images/validation-alert-icon.svg";
const SetupAccount = () => {
 


  return (
    <div className="mobile-wrapper bg-grey-variant">

      <div className="mobile-wrapper-inner bg-grey-variant">
      
      <div className="signup-login-header clearfix">
        <div className="signup-login-header-top clearfix">
          <a className="back-link" href="#">Back</a>
          <span>Step 1 of 2</span> 

        </div>
        
          <h2>Let’s set up your account</h2>
          
        </div>
        <div className="row">
        <div className="col-12">
        <div className="mob-fld-wrap position-relative mb-2">
          <label className="form-label">Email</label>
          <input type="email" className="form-control mob-pr-44 validation-alert-brdr" name="email-fld" placeholder="Email" />
          <Button variant="" className="fld-close-btn"><img src={FldCloseIcon} /></Button>
          <div className="validation-alert"><img src={ValidationAlertIcon} /></div>
          <div className="mob-error-msg">Invalid email address</div>
        </div>
       </div>
        <div className="col-6 pe-2">
        <div className="mob-fld-wrap position-relative mb-4">
          <label className="form-label">First name</label>
          <input type="email" className="form-control mob-pr-44 validation-alert-brdr" name="email-fld" placeholder="Email" />
          <Button variant="" className="fld-close-btn"><img src={FldCloseIcon} /></Button>
          <div className="validation-alert"><img src={ValidationAlertIcon} /></div>
          <div className="mob-error-msg">Invalid email address</div>
        </div>
        </div>
        <div className="col-6 ps-2">
        <div className="mob-fld-wrap position-relative mb-4">
          <label className="form-label">Last name</label>
          <input type="email" className="form-control mob-pr-44 validation-alert-brdr" name="email-fld" placeholder="Email" />
          <Button variant="" className="fld-close-btn"><img src={FldCloseIcon} /></Button>
          <div className="validation-alert"><img src={ValidationAlertIcon} /></div>
          <div className="mob-error-msg">Invalid email address</div>
        </div>

        </div>
        <div className="col-12">
        <label className="form-check-label checkbox-label mb-28" for="IAmRepresenting1">
          <input className="form-check-input" type="checkbox" id="IAmRepresenting1" />
          I'm a real-estate professional
        </label>
        </div>
        </div>

        <Button variant="primary" className="btn w-100 mb-4" disabled>Continue</Button>

        

        

        
        
        
        
        
                       
        
      </div>
    </div>
  );
};

export default SetupAccount;
